module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_8019.9be916a1.png";